// v-hover-photo="{ src, focal }" on a plain menu-card <img>: lays a second photo exactly over it
// that fades in while the mouse is over the card image and back out when it leaves. Nothing
// moves (the overlay copies the image's box, crop and rounding). Touch devices: not attached,
// so the hover photo is never downloaded there. Rules: utils/dishPhoto.js (cardPhotos).
import { canHover } from '@/utils/dishPhoto';

function sync(img, ov) {
  const cs = getComputedStyle(img);
  Object.assign(ov.style, {
    position: 'absolute', left: `${img.offsetLeft}px`, top: `${img.offsetTop}px`, width: `${img.offsetWidth}px`, height: `${img.offsetHeight}px`,
    objectFit: cs.objectFit || 'cover', borderRadius: cs.borderRadius, margin: '0', maxWidth: 'none',
  });
}

function detach(img) {
  const st = img.__hoverPhoto;
  if (!st) return;
  st.host.removeEventListener('mouseenter', st.on); st.host.removeEventListener('mouseleave', st.off);
  if (st.ro) st.ro.disconnect();
  st.ov.remove();
  delete img.__hoverPhoto;
}

function attach(img, value) {
  const v = value || {};
  const cur = img.__hoverPhoto;
  if (cur && cur.src === v.src) return;
  detach(img);
  if (!v.src || !canHover() || v.src === img.currentSrc || v.src === img.getAttribute('src')) return;
  const host = img.parentElement;
  if (!host) return;
  if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
  const ov = document.createElement('img');
  ov.src = v.src; ov.alt = ''; ov.setAttribute('aria-hidden', 'true'); ov.decoding = 'async';
  ov.className = `${img.className} chds-hover-photo`.trim();
  // the page's scoped styles (data-v-*) must reach the overlay too, so it zooms / rounds / moves
  // exactly like the photo under it (e.g. the homepage cards' zoom on hover)
  [...img.attributes].forEach((a) => { if (a.name.startsWith('data-v-')) ov.setAttribute(a.name, ''); });
  // keep the card's own image animation (e.g. the zoom on hover) and add the fade
  const own = getComputedStyle(img).transition;
  const fade = 'opacity .35s ease';
  Object.assign(ov.style, { opacity: '0', transition: own && !/^all 0s/.test(own) ? `${own}, ${fade}` : fade, pointerEvents: 'none', zIndex: '1' });
  ov.style.objectPosition = v.focal && v.focal.x != null ? `${v.focal.x}% ${v.focal.y}%` : getComputedStyle(img).objectPosition;
  img.insertAdjacentElement('afterend', ov);
  sync(img, ov);
  const on = () => { sync(img, ov); ov.style.opacity = '1'; };
  const off = () => { ov.style.opacity = '0'; };
  host.addEventListener('mouseenter', on); host.addEventListener('mouseleave', off);
  let ro = null;
  if (window.ResizeObserver) { ro = new ResizeObserver(() => sync(img, ov)); ro.observe(img); }
  img.__hoverPhoto = { src: v.src, ov, host, on, off, ro };
}

export default {
  mounted(el, b) { attach(el, b.value); },
  updated(el, b) { attach(el, b.value); },
  beforeUnmount(el) { detach(el); },
};
